import React, { useState } from 'react'

import api from '../../../services/api'
import Alert from '../../../components/Alert'
import { ButtonDelete } from '../../../components/ButtonDelete'

export default function ApagarPermissao({
  api_id,
  permission_id,
  afterDelete
}) {
  const [alert, setAlert] = useState()

  async function deletePermissao() {
    const r = await api.delete(`/apis/${api_id}/permissoes/${permission_id}`)
    if ('status' in r && r.status === 204) {
      setAlert(<Alert color="success">Permissão apagada!</Alert>)
      afterDelete()
    } else {
      setAlert(
        <Alert color="danger">
          Não foi possível excluir a Permissão.
          <br />
          Tente novamente ou entre em contato com o suporte da Central do
          Desenvolvedor.
        </Alert>
      )
    }
  }

  return (
    <>
      {alert}
      <ButtonDelete
        onClick={e => {
          e.preventDefault()
          if (window.confirm('Tem certeza que deseja remover esta permissão?'))
            deletePermissao()
        }}
        title="Remover permissão"
      />
    </>
  )
}
